// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import VueCookies from 'vue-cookies'
import { Tabs, Tab } from 'vue-tabs-component'
// import Vue2TouchEvents from 'vue2-touch-events'
import './assets/sass/custom.scss'
import Blank from './layouts/Blank.vue'
import Recharge from './layouts/Recharge.vue'
import EplNew from './layouts/EplNew.vue'
import Signup from './layouts/Signup.vue'
// Vue.use(Vue2TouchEvents)

// Vue.component('tabs', Tabs)
// Vue.component('tab', Tab)

Vue.component('blank-layout', Blank)
Vue.component('recharge-layout', Recharge)
Vue.component('eplNew-layout', EplNew)
Vue.component('signup-layout', Signup)

Vue.use(VueAxios, axios)

Vue.use(VueCookies)
Vue.prototype.$scrollToTop = () => window.scrollTo(0, 0)

Vue.config.productionTip = false
Vue.directive('numericOnly', {
  bind (el) {
    el.addEventListener('keydown', (event) => {
      if ([46, 8, 9, 27, 13, 110].indexOf(event.keyCode) !== -1 ||
        // Allow: Ctrl+A
        (event.keyCode === 65 && event.ctrlKey === true) ||
        // Allow: Ctrl+C
        (event.keyCode === 67 && event.ctrlKey === true) ||
        // Allow: Ctrl+X
        (event.keyCode === 88 && event.ctrlKey === true) ||
        // // Allow: Ctrl+V
        // (event.keyCode === 86 && event.ctrlKey === true) ||
        // Allow: home, end, left, right
        (event.keyCode >= 35 && event.keyCode <= 39)) {
        // let it happen, don't do anything
        return
      }
      // Ensure that it is not a number and stop the keypress
      if ((event.shiftKey || (event.keyCode < 48 || event.keyCode > 57)) && (event.keyCode < 96 || event.keyCode > 105)) {
        event.preventDefault()
      }
    })
  }
})
Vue.directive('focus', {
  inserted: function (el) {
    el.focus()
  }
})

new Vue({
  el: '#epaylater',
  store,
  router,
  components: { App },
  template: '<App/>'
})

Vue.filter('formatDate', function (value) {
  if (!value) return ''
  value = new Date(value)
  const monthArray = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec']
  const day = value.getDate()
  const month = monthArray[value.getMonth()]
  const year = value.getFullYear()
  return day + ' ' + month + ', ' + year
})
Vue.filter('formatDate2', function (value) {
  return Intl.DateTimeFormat('en-IN', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    weekday: 'short'
  }).format(value)
})
Vue.filter('captialize', function (value) {
  if (!value) return ''
  value = value.toLowerCase()
  var letter = value.substr(0, 1)
  var name = value.substr(1, value.length)
  value = letter.toUpperCase() + name
  return value
})

Vue.filter('formatCurrency', function (amount) {
  return new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR' }).format(amount)
})

Vue.filter('formatRate', function (value) {
  if (!value) return ''
  var newValue = ''
  if (value === 'PERCENTAGE') {
    newValue = '%'
  } else if (value === 'Fixed') {
    newValue = 'Fixed'
  } else {
    newValue = 'Rs.'
  }
  return newValue
})



// WEBPACK FOOTER //
// ./src/main.js